// Ο διακόπτης, τα δικαιώματα του χρήστη και οι κατηγορίες εξόδων, φρέσκα σε κάθε άνοιγμα του «Ταμείου»
// (χωρίς F5 στα ανοιχτά ταμεία). Αποτυχία ή παλιό backend = κλειστό: η καρτέλα δεν εμφανίζεται.

import { useCallback, useEffect, useState } from 'react';
import { cashMovementsApi, type CashMovementsConfig } from './api';

export function useCashMovementsConfig(storeId: number | null | undefined) {
  const [state, setState] = useState<{ id: number | null; config: CashMovementsConfig | null; loaded: boolean }>(
    { id: null, config: null, loaded: false },
  );
  const load = useCallback(async (alive: () => boolean = () => true) => {
    if (!storeId) return;
    let config: CashMovementsConfig | null = null;
    try {
      const c = await cashMovementsApi.config(storeId);
      config = c && typeof c === 'object'
        ? { ...c, enabled: c.enabled === true, canCreate: c.canCreate === true, canVoid: c.canVoid === true, categories: Array.isArray(c.categories) ? c.categories : [] }
        : null;
    } catch {
      config = null;
    }
    if (alive()) setState({ id: storeId, config, loaded: true });
  }, [storeId]);

  useEffect(() => {
    let alive = true;
    load(() => alive);
    return () => { alive = false; };
  }, [load]);

  const current = state.id === storeId ? state : { config: null, loaded: false };
  return { config: current.config, loaded: current.loaded, enabled: current.config?.enabled === true, reload: () => load() };
}
